import { useEffect, useState } from "react";
import * as Bananas from "bananas-commerce-admin";

import { ObituaryMediaResponse } from "../types";

export const useObituary = (obituaryId: number) => {
  const [data, setData] = useState<ObituaryMediaResponse>();
  const api = Bananas.useApi();

  const fetchData = async (): Promise<ObituaryMediaResponse | undefined> => {
    const operation = api.operations["mediahouse.obituaries:get"];
    const response = await operation?.call({
      params: { obituary_id: obituaryId },
    });
    if (!response?.ok) return;
    const responseJson: ObituaryMediaResponse = await response.json();
    setData(responseJson);
    return responseJson;
  };

  const refresh = () => {
    fetchData();
  };

  useEffect(() => {
    if (data != null) return;
    refresh();
  }, []);

  return { data, refresh };
};
